/* JumpLink */

const selectors = {
	container: '.js-jumplink__container',
	trigger: 'js-jumplink__trigger',
	target: 'js-jumplink__target',
};
Object.freeze(selectors);

const module = {

	init() {
		let $container = document.querySelector(selectors.container);
		if ($container) {
			module._initEvents($container);
		}
	},

	_initEvents($container) {
		$container.addEventListener('click', module._containerClickEvent);
	},

	_containerClickEvent(event) {
		// Find the closest anchor element with the trigger class
		let trigger = event.target.closest('a.' + selectors.trigger);

		if (trigger) {
			event.preventDefault();

			// Remove is-active class from all triggers
			let allTriggers = document.querySelectorAll('.' + selectors.trigger);
			allTriggers.forEach(t => t.classList.remove('is-active'));

			// Add is-active class to clicked trigger
			trigger.classList.add('is-active');

			let hash = decodeURIComponent(trigger.hash);
			let target = document.querySelector(hash);

			if (target) {
				const currentScrollPosition = window.pageYOffset;
				const targetAbsolutePosition = target.getBoundingClientRect().top + currentScrollPosition;

				// Determine scroll direction and set offset
				const isScrollingDown = targetAbsolutePosition > currentScrollPosition;
				const offset = isScrollingDown ? 63 : 143;
				// jumplink height / jumplink height + header height
				const targetPosition = targetAbsolutePosition - offset;
				window.scrollTo({
					top: targetPosition,
					behavior: "smooth"
				});
			}
		}
	},

};

export { module as JumpLink };
